import { LightweightElementsRecord } from "@/store/lightweight-elements-slice";
import { GUID } from "@faro-lotv/ielement-types";
import { IElementsRecord } from "@faro-lotv/project-source";
import { elementToTreeData, TreeData } from "./tree-data";

/**
 * @returns The tree representation of the whole project without any filtering or ordering logic
 * @param parentId ID of the parent of the current recursion level
 * @param elements All IElements of the project
 */
export function generateUnfilteredTree(
  parentId: GUID,
  elements: LightweightElementsRecord | IElementsRecord,
): TreeData[] {
  const subtree: TreeData[] = [];

  const parentElement = elements[parentId];
  if (!parentElement) return subtree;

  // The iElements of the current level of recursion
  const levelElementIds = parentElement.childrenIds ?? [];

  for (const elementId of levelElementIds) {
    const element = elements[elementId];

    // element might be undefined in case of `elementId` being invalid
    if (!element) continue;

    const { id, name, type, typeHint } = element;
    const children = generateUnfilteredTree(id, elements);

    subtree.push(
      elementToTreeData({
        element,
        parentElement,
        label: `${name} - ${type}(${typeHint}) - ${id}`,
        children,
      }),
    );
  }

  return subtree;
}
